import React, { useEffect, useState, useContext } from "react"
import { SettingsContext } from "../../providers/settings";
import HomePageLayout from "../../layouts/HomePage/HomePageLayout";
import { Grid, Stack, ArrowBack, GTIWebButton, GTIWebTabs, GTIWebTabPanel, GTIWebSelect, GTIWebTextField } from "@gti-controls-v2/web-core";
import Title from "../../components/title";
import ModalTicket from "../../components/modal-ticket";
import { useNavigate, useLocation } from "react-router-dom";
import homePageStyles from "../../common/styles/HomePage";
import useSearch from "../../hooks/useSearch";
import useLookup from "../../hooks/useLookups";
import useModal from "../../hooks/useModal";
import useTicket from "../../hooks/useTicket";
import HistoryMo from "./history";
import Companies from "./companies";
import Payrolls from "./payrolls";
import Modules from "./modules";
import HeaderInfo from "./header";
import Security from "./security";
import { paths } from "../../common/constants/Rutas";

const TicketPage = () => {
    const styles = homePageStyles;
    const initReasonState = {
        ticketReason: {
            motivoTicket: 0,
            medioTicket: 0,
            referencia: ""
        },
    };
    const { isLoading, handleLoading } = useContext(SettingsContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { getTicketsByUser } = useSearch();
    const { getCloseMotTicket } = useLookup();
    const { isShowing, open, close } = useModal();
    const { putCreateTicket } = useTicket();
    const [ticketId, setTicketId] = useState(0);
    const [ticketTitle, setTicketTitle] = useState("Ticket");
    const [employee, setEmployee] = useState({});
    const [user, setUser] = useState({});
    const [motivoTicket, setMotivoTicket] = useState(null);
    const [reasonTicket, setReasonTicket] = useState(initReasonState);
    const [errors, setErrors] = useState({});
    const [errorTicket, setErrorTicket] = useState(null);
    const [data, setData] = useState({});

    useEffect(() => {
        const state = location.state || {};

        handleLoading(true);

        if (state?.TicketID) {
            setTicketTitle("Ticket #" + state?.TicketID);
            setTicketId(state?.TicketID);
            getTicketsByUserHandler();
        } else {
            navigate(paths.ResultSearchPage);
            handleLoading(false);
        }
        
        // eslint-disable-next-line
    }, [location.state]);

    const handleBack = () => {
        navigate(-1);
    };
    

    const getTicketsByUserHandler = async () => {
        const resultEmployee = await getTicketsByUser(location.state.TicketID);

        if (resultEmployee.exitoso) {
            setData(resultEmployee.data);
            const birthDate = new Date(resultEmployee.data.Employee.AutoUserFecNac);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const hasBirthdayPassed =
                today.getMonth() > birthDate.getMonth() ||
                (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

            if (!hasBirthdayPassed) {
                age--;
            }
            
            setEmployee({...resultEmployee.data.Employee, Edad: age });
            setUser(resultEmployee.data?.User ?? {});
        }
        handleLoading(false);
    };

    const handleCloseTicket = async (e) => {
        try {
            handleLoading(true);
            const resultMotivos = await getCloseMotTicket();
            handleLoading(false);

            if (resultMotivos.exitoso) {
                setMotivoTicket(resultMotivos.data);
                open(ticketId);
            }
        } catch (error) {
            handleLoading(false);
        }
    };

    const onModalClosed = async (confirm) => {
        if (confirm) {
            if (validateReason()){
                let resultPostTicket;

                try {
                    const bodyTicket = {
                        ClasTikID: reasonTicket.ticketReason.motivoTicket,
                        Observa: reasonTicket.ticketReason.referencia,
                        TicketID: ticketId
                    };

                    resultPostTicket = await putCreateTicket(bodyTicket);

                    if (resultPostTicket?.exitoso) {
                        close();
                        navigate(paths.HomePage)
                    } else{
                        setErrorTicket({
                            message: resultPostTicket.data
                        });
                    }
                } catch (error) {
                    console.log("[Error on putCreateTicket]:", error);
                    setErrorTicket({
                        message: "Ocurrió un error."
                    });
                }
            }
        } else {
            close();
        }
    };

    const handlerOnChange = (e) => {
        setErrors({});
        const { name, value } = e.target;
        setReasonTicket((prev) => ({
            ...prev,
            ticketReason: {
                ...prev.ticketReason,
                [name]: value,
            },
        }));
    };

    const validateReason= () => {
        const newErrors = {};
        if (reasonTicket.ticketReason.motivoTicket === 0) {
            newErrors.motivoTicket = "Seleccione un motivo";
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSecurityDataUpdate = (updatedData) => {
        if(updatedData.type === 'phone'){
            setUser(prev => ({...prev, UsuarioCelular: updatedData.value, UsuarioCelStatus: 2}));
        } else if (updatedData.type === 'email'){
            setUser(prev => ({...prev, UsuarioEmail: updatedData.value, UsuarioEmailStatus: 2}));
        }
    }

    return (
        <HomePageLayout>
            <ModalTicket 
                open={isShowing} 
                title="Cerrar Ticket"
                onClose={onModalClosed} 
                error={errorTicket}  
                isLoading={isLoading}
            >
                <Stack spacing={2}>
                    <GTIWebSelect
                        name="motivoTicket"
                        dataSource={motivoTicket}
                        displayedValue="ClasTikNombre"
                        selectedValue="ClasTikID"
                        labelText="Seleccionar motivo de cierre"
                        color={"secondary"}
                        onChange={handlerOnChange}
                        disableDefaultReadOnly
                        required
                        error={errors.motivoTicket}
                    />

                    <GTIWebTextField
                        name="referencia"
                        labelText="Referencia (Opcional)"
                        width="100%"
                        autoFocus={true}
                        autoComplete={"off"}
                        onBlur={handlerOnChange}
                        onChange={handlerOnChange}
                        textArea={5}
                    />
                </Stack>
            </ModalTicket>

            <Stack direction="column" spacing={2} align="left" paddingBottom={5}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <GTIWebButton 
                        icon={<ArrowBack/>}
                        iconPosition="start"
                        onlyIcon={true}
                        onClick={handleBack}
                        loading={isLoading}
                    />
                    <Title>{ticketTitle}</Title>
                </Stack>
            </Stack>

            <Grid sx={styles.tabsContainer}>
                <HeaderInfo employee={employee} user={user} handleCloseTicket={handleCloseTicket} />
            </Grid>

            <Grid sx={styles.tabsContainer}>
                <GTIWebTabs>
                    <GTIWebTabPanel label="Opciones de Seguridad"><Security employee={employee} user={user} TicketID={ticketId} onDataUpdate={handleSecurityDataUpdate}/></GTIWebTabPanel>
                    <GTIWebTabPanel label="Bitácora de Recibos"><Payrolls CURP={employee?.AutoUserCURP ?? ''}  data={data.Recibos}/></GTIWebTabPanel>
                    <GTIWebTabPanel label="Historial Laboral"><Companies CURP={employee?.AutoUserCURP ?? ''} TicketID={ticketId}  data={data.Historial}/></GTIWebTabPanel>
                    <GTIWebTabPanel label="Módulos Disponibles"><Modules Employee={employee} empresaData={data?.Historial} data={data.Modulos} /></GTIWebTabPanel>
                    <GTIWebTabPanel label="Historial +ORDEN"><HistoryMo TicketID={ticketId} data={data.HistorialMO} lookup={data?.Lookups?.Dispositivos}/></GTIWebTabPanel>
                </GTIWebTabs>
            </Grid>

        </HomePageLayout>
    )
};

export default TicketPage;